import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

// Whether the record is editable is decided by CalculatedAttributeEditDispatcher from the
// attribute's own `type` (fetched from the detail endpoint), not from a URL query param.
const CalculatedAttributesEditRoute = lazy(async () => {
  const { CalculatedAttributeEditDispatcher } = await import("@segments/CalculatedAttributeEditDispatcher");

  return { default: CalculatedAttributeEditDispatcher };
});

export const calculatedAttributesEditNRO: NavigationRoutingObject = {
  Component: CalculatedAttributesEditRoute,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("calculated-attributes-edit-page-heading", "Edit Calculated Attribute"),
  pageNameForTracking: () => "Edit Calculated Attribute",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("custom_calculated_attributes");
  },
  showInSearchResults: false,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/calculated_attributes/:appGroupId",
};
